import { showAlert } from "../../Components/Alert/Alert";

export const addItemToCart = (dispatch, cartItems, itemToAdd, alert) => {
  const exist = cartItems.filter(
    (item) => item.product._id === itemToAdd.product._id
  )[0];
  if (exist) {
    if (alert) {
      showAlert(
        dispatch,
        "info",
        "Item already in cart, Quantity Increased by 1."
      );
    }
    return cartItems.map((item) =>
      item.product._id === itemToAdd.product._id
        ? { ...item, quantity: item.quantity + 1 }
        : item
    );
  }
  showAlert(dispatch, "success", "Item Added To Cart");
  return [...cartItems, { ...itemToAdd, quantity: 1 }];
};

export const decreaseQuantity = (cartItems, item) => {
  const newCart = cartItems.map((cartItem) => {
    if (cartItem.product._id === item.product._id) {
      if (cartItem.quantity !== 1) {
        return { ...cartItem, quantity: cartItem.quantity - 1 };
      } else {
        return cartItem;
      }
    } else {
      return cartItem;
    }
  });

  return newCart;
};

export const removeItem = (cartItems, itemToRemove) => {
  const newCart = cartItems.filter(
    (cartItem) => cartItem.product._id !== itemToRemove.product._id
  );
  return newCart;
};
